import PortalAuthPage from '@/pages/portal/PortalAuth.tsx'
import usePicFieldTitle from '@/hooks/usePicFieldTitle.ts'

/** Signup / free demo access. Login lives on `/portal/login`. */
export default function PortalDemoPage() {
  usePicFieldTitle('Kostenlos testen')

  return <PortalAuthPage mode='signup' />
}
